import React, { useState } from 'react'

import { Col, Row } from 'antd'
import moment, { Moment } from 'moment'

import { getEndOfMonthNumbersReport } from 'core/application/csiDashboard/reports/getEndOfMonthNumbersReportResults'

import DatePicker from 'common/components/dataEntry/components/DatePicker'
import Button from 'common/components/general/Button'
import Icon from 'common/components/general/Icon'

import { queryRequest } from 'common/RequestUtils'
import { Card } from 'common/components'
import { downloadExcel } from 'common/downloadFile'
import { useQueryRequest } from 'common/hooks'

interface ReportSectionProps {
  name: string
}

const ReportSection = ({ name }: ReportSectionProps) => {
  const [, loading, sendGetDownloadReport] = useQueryRequest(null)

  const [month, setMonth] = useState<string>(null)

  const handleMonthChange = (date: Moment | null, dateString: string) => {
    setMonth(dateString)
  }

  const handleSubmit = async () => {
    const result = await queryRequest(() => getEndOfMonthNumbersReport({ month }))

    if (result) {
      downloadExcel(result, `${name}.xlsx`)
    }
  }

  return (
    <Card title={name}>
      <Row className="mt-16">
        <Col span={8}>
          <DatePicker
            placeholder="Select Month"
            className="w-100"
            format={'YYYY/MM'}
            picker="month"
            onChange={handleMonthChange}
            allowClear={false}
          ></DatePicker>
        </Col>
      </Row>
      <Row className="mt-16">
        <Col span={8}>
          <Button type="primary" disabled={month === null} loading={loading} onClick={handleSubmit}>
            Download Report
          </Button>
        </Col>
      </Row>
    </Card>
  )
}

export default ReportSection
